import React from 'react';
import '../assets/css/style.css';
import { useState } from 'react';

import frontend from "../"


// import bannerImage from "../assets/img/ban1.jpg";
import bannerImage from "../assets/img/homebanner.jpg";

import machinelearning from "../assets/img/machine-learning.jpg";
import cloudcomputing from "../assets/img/cloud-computing.jpg";
import datascience from "../assets/img/data-science.jpg";
import devops from "../assets/img/devops.jpg";
import iot from "../assets/img/iot.jpg";
import cybersecurity from "../assets/img/cyber-security.jpg";
import aiimg from "../assets/img/ai-img.jpg";
import surveyscr from "../assets/img/surveyscr1.svg";


import auImage from "../assets/img/au.jpg";
import auSmallImage from "../assets/img/ausmall.jpg";
import wikiImage from "../assets/img/wiki.png";
import ISNImage from "../assets/img/ISN.png";
import MOImage from "../assets/img/MO.png";
import SCImage from "../assets/img/SC.png";
import industry from "../assets/img/industry.jpg"
import quoteimg from "../assets/img/quote-i.svg";
import industry1 from "../assets/img/industry1.svg";
import industry2 from "../assets/img/industry2.svg";

import { Link, NavLink } from 'react-router-dom';
import LatestNewsTrend from './LatestNewsTrend';
import Faqsection from './Faqsection';
import CardContainer from './CardContainer';
import {
  Target,
  Users,
  Clock,
  TrendingUp,
  Star,
  ArrowUp,
  CirclePlus,
  UserPlus,
  Users2,
  Search,
  MessageCircleQuestionMark,
  Lightbulb,
  ChartBar,
} from "lucide-react";
import CTA from './CTA';

import bannerimg from "../assets/img/bannerbg.jpg";
import Banner from './Banner';

const LandingPage = () => {

// State for active accordion
  const [activeAccordion, setActiveAccordion] = useState(null);

  // Toggle function for accordion
  const toggleAccordion = (accordionId) => {
    setActiveAccordion(prevState => (prevState === accordionId ? null : accordionId));
  };

  return (
    <div>
      

      <Banner
        title="Research "
        containerWidth="w-50"
        highlight="Fuels Innovation. Insight Drives Change."
        subtitle="At I&P, we empower professionals to Express, Explore, and Exchange insight that shapes the industries of tomorrow."
        bgImage={bannerimg}
        primaryBtn={{
          text: "Find People & Companies",
          link: "/apply",
          bgcolor: "",
        }}
        // secondaryBtn={{
        //   text: "Connect with us",
        //   link: "/contact",
        //   bgcolor: "bg-transparent border border-white bgwhitebtn",
        // }}
      />

      <section className="ptb60px pb170px px-3 aboutsection" style={{ backgroundColor: "#F3F8FF" }}>          
        <div className="container mx-auto d-flex flex-column flex-lg-row align-items-center gap-10">

          {/* Left */}
          <div className="w-100 md:tw-w-[70%] lg:tw-w-[40%] space-y-6">
            <div className="position-relative tw-pl-[38px] industryimagebox">

              <img
                data-aos="zoom-out-up"
                data-aos-delay="500"
                data-aos-duration="1000"
                src={industry1}
                alt="Industry"
                className="rounded-6 shadow w-100 h-auto object-fit-cover"
              />

              <div
                className="industryimageone tw-absolute tw-bottom-[-100px] tw-left-[0px] md:tw-left-[-38px]"
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="500"
              >
                <img
                  src={industry2}
                  alt="Person Working"
                  className="rounded-6 shadow w-100 h-auto object-fit-cover"
                />
              </div>

              <div
                className="industryimagetwo tw-absolute tw-bottom-[-100px] tw-right-0 tw-h-[185px] tw-w-[185px] tw-bg-[#CB333F] tw-text-white tw-px-6 tw-py-4 tw-rounded-full"
                data-aos="zoom-in-down"
                data-aos-delay="1000"
                data-aos-duration="1500"
                data-aos-easing="ease-in-out"
              >
                <span className="position-relative tw-z-[2] tw-text-[20px] inter tw-text-white tw-font-semibold tw-leading-[26px] tw-inline-block tw-pt-[10px] tw-pl-[5px]">
                  Fueling innovation through your contribution
                </span>
              </div>

            </div>
          </div>

          {/* Right */}
          <div className="w-100 lg:tw-w-[60%] tw-pt-[100px] lg:tw-pt-[60px]">

            <div className="headingbox">
              <h2
                className="headinglg mb-4"
                data-aos="fade-up"
                // data-aos-delay="500"
                // data-aos-duration="1000"
                // data-aos-easing="ease-in-out"
              >
                <span className="uline">
                  The Idea That Shapes{" "}
                  <span className="textred2">Industry & People</span>
                </span>
              </h2>
            </div>

            <p className="graytext mb-4 fs16px" data-aos="fade-up">
              Industry & People is a research-driven platform designed to bring
              authentic industry insights to professionals and organizations alike.
            </p>

            <p className="graytext mb-4 fs16px" data-aos="fade-up">
              Every successful participation comes with an honorarium,
              recognizing your role in advancing industry understanding.
            </p>

            <p className="textred fst-italic mb-12 fs16px" data-aos="fade-up">
              Join Industry & People today and be part of a purposeful
              initiative that drives innovation and growth.
            </p>

            <CTA
              btnlink="/about"
              btntext="About Us"
              bgcolor="mt-4 d-inline-block fw-semibold text-white px-5 py-3 bgred rounded-8 bgblackhover"
              // hoverbgcolor="hover:"
            />

          </div>

        </div>
      </section>

      <section className="px-3 position-relative w-100 tw-bg-cover tw-bg-center ptb60px pb100px" style={{ backgroundImage: `url(${industry})` }}>
          {/* Overlay */}
          <div className="tw-absolute tw-inset-0 tw-bg-black/90"></div>

          <div className="position-relative container tw-mx-auto tw-z-10">

            {/* Heading */}
            <div
              className="headingbox tw-text-center tw-mb-10 w-100 md:tw-max-w-[55%] tw-mx-auto"
              data-aos="fade-up"
            >
              <h2 className="tw-text-[32px] tw-leading-[40px] tw-font-bold tw-mb-[15px] tw-text-white">
                <span className="uline">How Industry & People Works</span>
              </h2>

              <p className="tw-text-[18px] aeonik tw-leading-[27px] tw-font-[400] tw-text-white">
                Discover how your insights can drive industry change and create
                real impact.
              </p>
            </div>

            {/* Grid */}
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-6 tw-gap-6 tw-mt-[50px]">

              {[
                { id: 1, title: "Apply for membership", desc: "People from all industries join this platform.", icon: <UserPlus size={20} /> },
                { id: 2, title: "Join the Industry Community", desc: "Engage with professionals.", icon: <Users size={20} /> },
                { id: 3, title: "Explore Companies & People", desc: "Discover organizations.", icon: <Search size={20} /> },
                { id: 4, title: "Ask Questions From Experts", desc: "Get insights from experts.", icon: <MessageCircleQuestionMark size={20} /> },
                { id: 5, title: "Share Expertise", desc: "Help others with your knowledge.", icon: <Lightbulb size={20} /> },
                { id: 6, title: "Gain & Share Insight", desc: "Learn and grow.", icon: <ChartBar size={20} /> }
              ].map((item) => (
                <div key={item.id} className="position-relative tw-flex tw-justify-center tw-mb-[40px] lg:tw-mb-0">

                  {/* Red Layer */}
                  <div className="red-shape-box">

                    {/* Arrow */}
                    <div className="custom-arrow-shape" />
                  </div>

                  {/* Card */}
                  <div className="tw-bg-transparent tw-w-[93%] lg:tw-w-[140px] md:tw-w-[90%]
                                  tw-h-[200px] sm:tw-h-[210px] md:tw-h-[200px] lg:tw-h-[220px]
                                  [perspective:1000px]">

                    <div className="position-relative w-100 tw-h-full tw-text-center
                                    tw-transition-transform tw-duration-[800ms]
                                    [transform-style:preserve-3d]
                                    md:hover:[transform:rotateY(180deg)]">

                      {/* Front */}
                      <div className="tw-absolute tw-inset-0 tw-bg-[#eef5fb] tw-rounded-[28px]
                                      tw-border-4 tw-border-white tw-flex tw-flex-col tw-items-center
                                      tw-px-4 tw-py-4 tw-z-10
                                      [backface-visibility:hidden]">

                        <div className="tw-w-12 tw-h-12 tw-mb-3 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-800 tw-text-white tw-text-[14px] tw-font-semibold">
                          {item.id}
                        </div>

                        <h3 className="fs16px tw-leading-[22px] tw-font-bold textred">
                          {item.title}
                        </h3>

                        <div className="tw-mt-auto tw-w-16 tw-h-16 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#A71D27] tw-text-white">
                          {item.icon}
                        </div>
                      </div>

                      {/* Back */}
                      <div className="tw-absolute tw-inset-0 tw-bg-[#111827] tw-text-white
                                      tw-flex tw-flex-col tw-items-center tw-justify-center
                                      tw-rounded-[20px]
                                      [transform:rotateY(180deg)]
                                      [backface-visibility:hidden]
                                      tw-p-3 tw-text-center">

                        {/* <h3 className="inter tw-font-semibold tw-leading-[22px] tw-mb-2 tw-text-[15px]">
                          {item.title}
                        </h3> */}

                        <p className="inter tw-text-[14px] tw-leading-[20px] tw-opacity-90">
                          {item.desc}
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
      </section>  

      <section className="ptb60px pb100px px-3">
        <div className="container mx-auto">

          {/* Heading */}
          <div
            className="headingbox text-center mb-5 w-100 mx-auto"
            data-aos="fade-up"
          >
              <h2 className="font-weight-bold mb-2 headinglg">
                <span className="uline">Who Are InP Members?</span>
              </h2>

              <p className="customtextgray textred fw-semibold mt-2">
                Great minds don’t think alike — they think together.
              </p>

              <p className="fs-17 aeonik mt-2">
                People from all industries join this platform to exchange insight and knowledge.
              </p>
          </div>

          {/* Tree Box */}
          <div className="treebox">
            <div className="position-relative w-100 tw-h-[600px]">

              {/* ITEM */}
              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[45px] tw-left-[0px] tw-bg-[#50AD87]">
                Transportation
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[95px] tw-left-[-233px] tw-bg-[#2A5D66]">
                Agriculture
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[150px] tw-left-[-85px] tw-bg-[#52A8C5]">
                Technology
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[245px] tw-left-[-220px] tw-bg-[#FFB772]">
                Healthcare
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[212px] tw-left-[-140px] tw-bg-[#4A91AF]">
                Finance
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[112px] tw-left-[-145px] tw-bg-[#C72430]">
                Manufacturing
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[25px] tw-left-[115px] tw-bg-[#50AD87]">
                Retail
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[45px] tw-right-[-35px] tw-bg-[#F37B80]">
                E-Commerce
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[85px] tw-right-[-280px] tw-bg-[#439472]">
                Real Estate
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[150px] tw-right-[-175px] tw-bg-[#C72430]">
                Energy & Utilities
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[250px] tw-right-[-285px] tw-bg-[#52A8C5]">
                Telecommunications
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-top-[350px] tw-right-[-155px] tw-bg-[#204E58]">
                Hospitality
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[125px] tw-right-[-130px] tw-bg-[#FFB772]">
                Education
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[55px] tw-right-[-63px] tw-bg-[#C72430]">
                Marketing
              </div>

              <div className="tw-px-6 tw-py-2 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-font-semibold tw-text-white fs16px tw-leading-[22px] tw-absolute tw-bottom-[25px] tw-right-[105px] tw-bg-[#356D74]">
                Legal
              </div>

            </div>
          </div>

        </div>
      </section>

      <section className="ptb60px pb100px px-3" style={{ backgroundColor: "#111827" }}>
        <div className="container mx-auto">

          <div className="d-flex flex-column flex-md-row align-items-center gap-5">

            {/* Left Content */}
            <div className="headingbox">

              <h2 className="text-white font-weight-bold headinglg mb-4" data-aos="fade-up">
                <span className="uline">
                  Create you own survey and do your own primary research!
                </span>
              </h2>

              <p
                className="text-white custom-text-lg font-weight-normal"
                data-aos="fade-up"
              >
                Earn points by sharing your though in others’ research surveys and spend the earned points for your research.
              </p>

              {/* List */}
              <div className="my-5 text-white custom-text" data-aos="fade-up">
                <ul className="list-unstyled custom-space">
                  <li className="d-flex align-items-center gap-3 my-3 font-weight-normal">
                    <Target size={18} /> Need feedback on a new product?
                  </li>
                  <li className="d-flex align-items-center gap-3 my-3 font-weight-normal">
                    <Target size={18} /> Looking for insights into customer behavior?
                  </li>
                  <li className="d-flex align-items-center gap-3 my-3 font-weight-normal">
                    <Target size={18} /> Want to conduct internal employee surveys?
                  </li>
                </ul>
              </div>

              <p className="text-white mb-4 fst-italic fs16px" data-aos="fade-up">
                Simply choose the type of survey you want, customize your questions, and launch it to get valuable feedback.
              </p>

              {/* Button */}
              <div className="mt-30" data-aos="zoom-in-left">
                <CTA
                  btnlink="/"
                  btntext="Create Now"
                  bgcolor="fw-semibold text-white px-5 py-3 bgred rounded-8"
                  hoverbgcolor="hover:tw-bg-[#8f1720]"
                />
              </div>

            </div>

            {/* Right Image */}
            <div className="max-width564 w-100">
              <img
                src={surveyscr}
                alt="Create-Surveys-Tailored"
                data-aos="zoom-in-down"
                className="rounded-10 w-100 h-auto object-fit-cover"
              />
            </div>

          </div>

        </div>
      </section>

      <CardContainer />

      <Faqsection />    

    </div>
  );
};

export default LandingPage;
